import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { Alert } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";

type AppAssistenteIAContextoToggleProps = {
	readonly manterContexto: boolean;
	readonly enviando: boolean;
	readonly onAlterar: (valor: boolean) => void;
};

const TooltipMantemContexto = () => (
	<div>
		<div className="gap-2 flex flex-col mb-2">
			<p>
				<span className="font-bold text-success">Quando ativado</span>, o assistente considera as mensagens
				anteriores para manter a continuidade da conversa.
			</p>
			<p>
				<span className="font-bold text-danger">Quando desativado</span>, cada nova pergunta é processada de
				forma independente.
			</p>
		</div>

		<Alert severity="info" variant="filled" className="text-xs items-center">
			O contexto da conversa é mantido temporariamente pelo seu provedor de IA e não é armazenado pelo sistema
			SPACE.
		</Alert>
	</div>
);

export default function AppAssistenteIAContextoToggle({
	manterContexto,
	enviando,
	onAlterar,
}: AppAssistenteIAContextoToggleProps) {
	return (
		<div className="flex items-center gap-1">
			<FormControlLabel
				className="m-0"
				control={
					<Checkbox
						size="small"
						color="secondary"
						className="p-0.5"
						checked={manterContexto}
						disabled={enviando}
						onChange={(event) => onAlterar(event.target.checked)}
					/>
				}
				label={<span className="text-sm text-muted-foreground">Manter contexto temporário da conversa</span>}
			/>
			<Tooltip title={<TooltipMantemContexto />} arrow placement="top">
				<span className="flex cursor-help items-center justify-center rounded-full text-muted-foreground hover:bg-primary/10 hover:text-primary">
					<FuseSvgIcon size={13}>lucide:info</FuseSvgIcon>
				</span>
			</Tooltip>
		</div>
	);
}
